
export default {
    namespaced: true,
    state: {
        selected: [],
    },
    getters: {
        SELECTED: state => {
            return state.selected;
        },
    },
    mutations: {
        SELECTED: (state, payload) => {
            return state.selected = payload;
        },
    },
    actions: {
        SAVE: async ({state, dispatch}, payload) => {
            let data = {
                countries: state.selected,
            }
            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/demand-country',
                parameter: data,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    payload.th.isChange = false
                    dispatch('GET_DATA', {th: payload.th})
                },
                getResponse: () => {
                    payload.th.showOverlay --
                }
            });
        },
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/demand-country',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SELECTED', responseData.countries);
                    payload.th.isReady = true
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }

    }
}